<template>
  <v-app>
  <head>
    <title>Foraje - Find it, Grow it, Share it.</title>
    <meta name="description" content="Find more customers for your produce!">
  </head>
    <header>
      <div class="stripes">
        <span/>
        <span/>
        <span/>
        <span/>
        <span/>
      </div>
      <section>
        <v-container>
          <v-spacer></v-spacer>
          <v-row style="position: relative" align="center"
                 justify="center">
            <v-col cols="12" style="text-align: center">

              <h1 class="herotext">
                Grow your farm business
              </h1>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="newshop.name"
                placeholder="Enter the name of your shop"
                counter="200"
                hint="What is your shop called? ie Jim's Apples, Abbie's, River Farm, etc."
                filled
                background-color="white"
                :label="newshop.name ? 'Shop Name' : ''"
              />
            </v-col>
            <v-col cols="12" sm="3" md="2" style="height: 110px">
              <v-btn block style="height: 56px" @click="DialogSelection" color="primary">
                List Your Shop
              </v-btn>

            </v-col>
            <v-col cols="12" style="text-align: center">

              <p>Find new customers, keep them, and increase your sales. All for free</p>
            </v-col>
            <v-col cols="10" sm="8" md="5">
              <v-img src="../assets/farmstand.svg"/>
            </v-col>


          </v-row>
        </v-container>
      </section>
    </header>
    <v-dialog v-model="shop_create_dialog" persistent overlay-opacity="160" no-click-animation>
      <v-row
      >
        <v-col cols="11">

        </v-col>
        <v-col cols="1">
          <v-btn icon dark @click="shop_create_dialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-col>
        <v-col cols="12" md="6" class="mx-auto">
          <form @submit.prevent="JustCreateNewShop">
            <v-card class="fill-height" flat>
              <v-card-text>
                <v-text-field
                  v-model="newshop.name"
                  label="Shop Name"
                  counter="200"
                  hint="What is your shop called? ie Jim's Apples, Abbie's, River Farm, etc."
                  required
                />
                <v-text-field
                  v-model="newshop.address"
                  label="Shop Address"
                  hint="Where is your shop located? Postal address preferable if possible (makes it easier for people to find you)"
                  counter="300"
                  required
                />
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-col cols="12" md="6">
                  <v-btn color="primary" type="submit" :loading="shop_create_loading" >
                    Submit your shop
                    <span slot="loader" class="custom-loader">
                        <v-progress-circular indeterminate color="green"></v-progress-circular>
                       </span>
                  </v-btn>
                </v-col>

              </v-card-actions>
            </v-card>
          </form>
        </v-col>
      </v-row>
    </v-dialog>
    <section>
      <v-dialog v-model="signup_shop_create_dialog" persistent overlay-opacity="160" no-click-animation>
          <v-row
          >
            <v-col cols="11">

            </v-col>
            <v-col cols="1">
<v-btn icon dark @click="signup_shop_create_dialog = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
            <v-col cols="12" md="6" class="mx-auto">
              <form @submit.prevent="CreateNewShopAndUser">
              <v-alert dismissible color="error" text icon="mdi-alert-outline" v-model="erroralert" style="margin-bottom: 2px">Sorry! Something seems to have gone wrong, we automatically track errors, so we'll try to figure out what happened. Try again later please!</v-alert>
              <v-alert dismissible color="success" text icon="mdi-check-circle" v-model="signupalert" style="margin-bottom: 2px">Success! Your shop has been created! Before you can sign in, you need to click the verification link in the email you provided.</v-alert>
              <v-alert dismissible color="error" text icon="mdi-alert-outline" v-model="termsalert" style="margin-bottom: 2px">If you would like to create an account on Foraje, you must accept and agree to the terms and conditions, content policy, and privacy policy</v-alert>
              <v-card class="fill-height" flat>
                  <v-card-text>
                    <v-text-field
                      v-model="newshop.name"
                      label="Shop Name"
                      counter="200"
                      hint="What is your shop called? ie Jim's Apples, Abbie's, River Farm, etc."
                      required
                    />
                    <v-text-field
                      v-model="newshop.address"
                      label="Shop Address"
                      hint="Where is your shop located? Postal address preferable if possible (makes it easier for people to find you)"
                      counter="300"
                      required
                    />
                    <v-text-field
                      name="email"
                      label="Email"
                      id="email"
                      v-model="email"
                      type="email"
                      hint="A real email, since you'll need to verify it. This will let you log in to edit your shop, list your products, etc."

                      required/>
                    <v-text-field
                      name="password"
                      label="Password"
                      id="password"
                      v-model="password"
                      :type="password_show ? 'text' : 'password'"
                      hint="At least 8 characters, up to 255, no special requirements just please don't use common words/passwords."
                      min="8"
                      :counter="255"
                      required
                      :append-icon="password_show ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="password_show = !password_show"

                    />
                      <v-checkbox
                        color="green"
                        v-model="termscheckbox"
                      >
                        <label slot="label">
                          Check here to indicate you have read and agree to the <router-link @click.stop to="/policies/terms">terms and conditions,</router-link> the <router-link @click.stop to="/policies/content">content policy</router-link> and the <router-link @click.stop to="/policies/privacy">privacy policy</router-link>
                        </label>
                      </v-checkbox>
                      <v-checkbox
                        color="green"
                        v-model="emailcheckbox"
                        label="Check here if you would like to receive email updates and newsletters"
                      >
                      </v-checkbox>
                  </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-col cols="12" md="6">
                    <v-btn color="primary" type="submit" :loading="shop_create_loading" >
                      Submit your shop
                      <span slot="loader" class="custom-loader">
                        <v-progress-circular indeterminate color="green"></v-progress-circular>
                       </span>
                    </v-btn>
                  </v-col>

                </v-card-actions>
              </v-card>
            </form>
            </v-col>
          </v-row>
      </v-dialog>
    </section>
    <section>
    <v-container>
      <v-row style="position: relative" align="center" justify="center">
        <v-col cols="4" style="text-align: center">
          <h3>Not looking to sell, just want to find local producers?</h3>
          <router-link :to="'/shop-finder/'">
            <v-btn class="ma-1" color="primary">Find local food now</v-btn>
          </router-link>
        </v-col>
      </v-row>
    </v-container>
    </section>
    <section>
      <v-container>
        <v-row style="position: relative" align="center"
               justify="center">
          <v-col cols="6">
          </v-col>
          <v-col cols="6">
            <p>
              Adding your farmstand to Foraje makes it easier for new customers to discover you and the convenient map makes your shop super easy to find.
            </p>
          </v-col>
<!--          Image Block-->
          <v-col cols="6" style="text-align: center">
            <h3>
              Find More Customers
            </h3>
          </v-col>
          <v-col cols="6">
            <v-img src="https://foraje-static-1.nyc3.digitaloceanspaces.com/media/static/images/misc/Foraje%20Shop%20Finder.png" style="max-height: 150px"></v-img>
          </v-col>
          <!--          /Image Block-->
          <v-col cols="6">
          </v-col>
          <v-col cols="6">
            <p>
             Plus, your current customers can follow your page and get updates whenever you update your inventory!
            </p>
          </v-col>
          <v-col cols="6" style="text-align: center">

            <h3>
              COVID-19 has changed things
            </h3>

          </v-col>
          <v-col cols="6" class="mt-4">
            <p>
              Due to the pandemic, many farmer's markets are closed, and customers are a bit more hesitant about grocery stores, avoiding them when possible.
              Plus, restaurant and other food service customer orders have dried up for a lot of producers.
            </p>
            <p>
              Foraje helps new customers to find you, and order directly from you, thus being able to avoid more crowded, and thus risky, gathering places.
            </p>
          </v-col>
          <v-col cols="6" style="text-align: center">

            <h3>
              It's free!
            </h3>

          </v-col>
          <v-col cols="6" class="mt-4">
            <p>
              It's 100% completely free to list your farmstand or shop and all your products.
            </p>
            <p>
              We want to help farmers, ranchers and other producers, that's what Foraje is all about.
            </p>
          </v-col>
          <v-col cols="6" style="text-align: center">

            <h3>
              It's super simple and easy
            </h3>

          </v-col>
          <v-col cols="6" class="mt-4">
            <p>
              Creating your shop on Foraje takes about 30 seconds.
            </p>
            <p>
              Just fill out this form, and confirm your email address and customers will be able to find you!
            </p>
          </v-col>

        </v-row>
      </v-container>
    </section>
    <section>
      <v-container>
        <v-row style="position: relative" align="center"
               justify="center">
          <v-col cols="6" style="text-align: center">

            <h3>
              Got questions?
            </h3>
          </v-col>
          <v-col cols="6">

            <p>
              Reach out to me directly at jon@foraje.com, or you can use any of the methods found on our <router-link :to="'contact'">contact page</router-link>
            </p>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </v-app>
</template>

<script>
import axios from 'axios';
import { validationMixin } from 'vuelidate';
import { email, required } from 'vuelidate/lib/validators';

export default {
  mixins: [validationMixin],
  validations: {
    email: { required, email },
    termscheckbox: { required },
  },
  name: 'VendorLandingPage',
  data: () => ({
    email: '',
    password: '',
    password_show: false,
    // confirmPassword: '',
    signupalert: false,
    termscheckbox: false,
    emailcheckbox: false,
    termsalert: false,
    erroralert: false,
    signuploading: false,
    signup_shop_create_dialog: false,
    shop_create_dialog: false,
    shop_create_loading: false,
    slug_lookup_loading: false,
    newshop: {
      name: '',
      address: '',
    },
    usertoken: '',
  }),
  methods: {
    CreateNewShopAndUser() {
      if (this.termscheckbox === true) {
        this.shop_create_loading = true;
        axios.post('user/registration/', {
          email: this.email,
          password1: this.password,
          password2: this.password,
        })
          .then((response) => {
            this.usertoken = response.data.key;
          })
          .then(() => {
            if (this.emailcheckbox === true) {
              axios.post('mailinglist/subscribe/', {
                email: this.email,
                email_consent: this.emailcheckbox,
              });
            }
          })
          .then(() => {
            const authheader = `Token ${this.usertoken}`;
            axios.post('forms/products/shops/create/', this.newshop, {
              headers: {
                Authorization: authheader,
              },
            });
          })
          .then(() => {
            this.shop_create_loading = false;
            this.signup_shop_create_dialog = false;
            this.$parent.$parent.$emit('alert-emitted', {
              alert_icon: 'mdi-check-circle',
              alert_color: 'success',
              alert_message: 'Shop Created! Once it\'s approved it will appear in other user\'s searches. Once you\'ve confirmed your email, you can sign in and edit it.',
              alert_model: true,
            });
          })
          .then(() => {
            this.$router.push('/sign_in');
          })
          .catch((error) => {
            // this regex fix is stilllll pretty hacky, but it seems to work now.
            const regex = /\[(.*?)\]/;
            this.signupalert = false;
            this.erroralert = true;
            this.$parent.$parent.$emit('alert-emitted', {
              alert_icon: 'mdi-emoticon-frown-outline',
              alert_color: 'error',
              alert_message: `Our system says: ${regex.exec(error.response.request.response)[1].replace(/['"]+/g, '')}`,
              alert_model: true,
            });
          });
      } else { this.termsalert = true; }
    },
    JustCreateNewShop() {
      this.shop_create_loading = true;
      const authheader = `Token ${this.$store.getters.token}`;
      axios.post('forms/products/shops/create/', this.newshop, {
        headers: {
          Authorization: authheader,
        },
      })
        .then(() => {
          this.shop_create_loading = false;
          this.shop_create_dialog = false;
          this.$parent.$parent.$emit('alert-emitted', {
            alert_icon: 'mdi-check-circle',
            alert_color: 'success',
            alert_message: 'Shop Created! Once it\'s approved it will appear in other user\'s searches.',
            alert_model: true,
          });
        })
        .then(() => {
          this.$router.push('/user/shops/');
        })
        .catch(
          () => {
            this.signupalert = false;
            this.erroralert = true;
          },
        );
    },
    DialogSelection() {
      if (this.$store.getters.token) {
        this.shop_create_dialog = true;
      } else { this.signup_shop_create_dialog = true; }
      axios.post('form/shop/first/', {
        shop: this.newshop.name,
      });
    },
  },
};
</script>

<style scoped>
  header .stripes {
    display: grid;
    grid: repeat(5, 200px) / repeat(10, 1fr);
    position: absolute;
    width: 100%;
  }

  header .stripes :nth-child(1) {
    grid-column: span 3;
    background: linear-gradient(100grad,rgba(243,251,255,.4),rgba(243,251,255,.15)
    20%,rgba(243,251,255,0));
  }

  header .stripes :nth-child(2) {
    grid-area: 3 / span 3 / auto / -1;
    background: linear-gradient(100grad,rgba(0,119,204,0), rgba(111,166,156,1));
  }

  header .stripes :nth-child(3) {
    grid-row: 4;
    grid-column: span 5;
    background: linear-gradient(100grad,#fafafa 50%,hsla(0,0%,100%,0));
  }
  header .stripes :nth-child(5) {
    grid-area: auto/1/-1/-1;
    background: linear-gradient(100grad,#fafafa 80%,#f5fafd)
  }
  header .stripes {
    transform: skewY(-12deg);
    transform-origin: 0;
  }
  header .stripes {
    background: linear-gradient(#2d796b, #468a7e 10%, #8dbbb3 38%, #add1cb 48%, #eaf1f0 62%)
    repeat scroll;
  }
  .herotext{
    font-weight: 500;
    color: #004b42;
    font-size: 5vmax;
  }

  .v-messages__message {
    color: #ffffff
  }

</style>
